import React, { useState } from "react";
import { IconButton, CircularProgress, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ExportAsPDFBtn = ({
  contentRef,
  fileName = "report.pdf",
  color = "#890089",
  iconColor = "white",
  ignoreClass = "no-export",
}) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!contentRef.current) return;

    setLoading(true);
    try {
      const element = contentRef.current;
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        ignoreElements: (element) => element.classList.contains(ignoreClass),
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;

      // Add subsequent pages if content is long
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(fileName);
    } catch (error) {
      console.error("PDF Export failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Download as PDF">
      <IconButton
        onClick={handleDownload}
        disabled={loading}
        sx={{
          position: "fixed",
          bottom: 14,
          right: 14,
          bgcolor: color,
          color: iconColor,
          width: 48,
          height: 48,
          "&:hover": { bgcolor: "#2C2E78", opacity: 0.9 },
          "&.Mui-disabled": { bgcolor: "action.disabledBackground" },
        }}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <DownloadIcon />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ExportAsPDFBtn;
